function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.06 73.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.59.98c-.67,1.08-1.97,11.48-3.38,26.98-.47,5.22-2.04,13.24-3.49,17.8-3.48,11.02-3.64,20.94-.38,24.64,2.09,2.37,2.91,2.56,11.56,2.67,8.42.11,9.54-.1,11.75-2.17,3.06-2.87,3.18-7.35.44-15.94-1.1-3.44-2-8.35-2-10.9,0-6.43-8.03-39.85-10.3-42.85-1.14-1.51-3.35-1.63-4.21-.23",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.03,20.02c2.15,8.49,4.21,18.22,4.58,21.6l.67,6.16-4.34-1.51c-2.73-.95-5.95-1.29-8.69-.92-3.87.52-4.27.39-3.63-1.16,1.52-3.69,2.44-8.96,2.49-14.25.03-3.03.44-7.3.92-9.5.48-2.2,1.19-7.09,1.57-10.86.42-4.16,1.05-6.5,1.61-5.94.51.51,2.68,7.87,4.83,16.36",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,50.21c2.46,2.26,5.66,10.28,5.66,14.21,0,1.15-.7,3.1-1.56,4.32-1.4,2-2.41,2.22-10,2.22s-8.73-.29-10.58-2.13c-1.93-1.93-2.08-2.89-1.58-10.2.66-9.66,1.59-10.66,9.85-10.66,4.57,0,6.26.46,8.21,2.25",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.7064af546af2c0e67dab7e0b0f974d37.svg";
export { ForwardRef as ReactComponent };